export default {
  sendWelcomeMail:'/mail/sendWelcomeMail',
}
